<template>
  <div class="item">
    <v-form v-if="project" v-model="validForm" ref="createItemForm" lazy-validation>
      <v-layout>
        <v-flex md4 lg4>
          <div class="v-card">
            <div class="card-title px-2 py-2">
              <span class="semibold">Name Item &amp; Upload File</span>
            </div>
            <v-divider></v-divider>
            <div class="upload-progress-wrapper">
              <v-progress-linear v-if="showProgress"
                                 :indeterminate="processing"
                                 v-model="fileProgress">
              </v-progress-linear>
            </div>
            <p class="px-2">
              <v-text-field label="Item Name"
                            v-model="project.name"
                            :rules="requiredRules"
                            autofocus>
              </v-text-field>
            </p>

            <p class="px-2 pb-2 semibold center-align">
              Upload A Single
              {{property('width').default}}″W x
              {{property('length').default}}″H PDF File<br>
            </p>

            <div class="center-align">
              <div style="display:inline-block; width:100%">
                <div v-if="hasFiles">
                  <img :src="project.file.thumbs.medium" alt="" class="elevation-5 uploaded-file">
                  <br>
                  <v-btn flat @click.prevent="saveItem(project.file.files.preview, true)">Preview File</v-btn>
                </div>
                <vue-transmit v-bind="transmitOptions"
                              @sending="showProgress = true"
                              @upload-progress="updateProgress"
                              @success="onUploadSuccess"
                              @error="errorUploading"
                              @timeout="onTimeout"
                              @drag-start="onDraging"
                              @drag-enter="onDraging"
                              @drag-over="onDraging"
                              @drag-end="onDroped"
                              @drag-leave="onDroped"
                              @drag-drop="onDroped"
                              ref="uploader"
                              class="aspect-ratio-box elevation-2"
                              :class="hideIfHasFiles"
                >
                  <div :class="dropable">
                    <br>
                    <v-icon class="mt-3 display-3">mdi-file-pdf-box</v-icon><br>
                    <br>
                    <strong>Drag Your PDF File Here</strong><br>
                    <br>
                    or<br>
                    <br>
                    <v-btn color="primary" large>Select a PDF File</v-btn>
                  </div>
                </vue-transmit>
              </div>
            </div>

            <div class="px-2 py-2">
              <p class="center-align">
                  <v-btn
                    color="primary"
                    large
                    v-if="hasFiles"
                    @click="triggerBrowse()"
                  >
                    Select a new PDF File
                  </v-btn><br>
                  <v-btn outline
                         target="_blank"
                         title="File Preparation Guidelines"
                         href="https://www.gungho.com/file-preparation-guidelines/">
                  File Preparation Help
                </v-btn>
              </p>
            </div>
          </div>
        </v-flex>

        <v-flex class="md6 lg6">
          <div class="v-card">
            <div class="card-title semibold px-2 py-2">
             Select Options
            </div>
            <v-divider></v-divider>
            <div class="px-2 pt-4">
				      <div v-for="property in project.product.properties" :class="{ hidden: !property.display }">
                <p class="semibold">{{property.title}}</p>

                <div v-if="property.pinned" class="pinned-checkbox">
                  <v-checkbox
                    v-for="option, index in property.options"
                    :label="option.label"
                    :key="option+index"
                    v-model="pinnedCheckbox"
                    on-icon="mdi-check-circle"
                    readonly
                    checked
                  ></v-checkbox>
                </div>

                <div v-else>
                  <v-radio-group
                    v-model="project.file[property.name]" :rules="requiredRules">
                    <v-radio
                      v-for="option, index in property.options"
                      :key="property.name+index"
                      :name="property.name"
                      :label="option.label"
                      :value="option.value"
                      :disabled="option.disabled"
                      validate-on-blur
                    ></v-radio>
                  </v-radio-group>
                </div>
              </div>
            </div>
            <div class="pl-1 pb-2">
              <v-btn :color="valid ? 'primary' : 'disabled'" :depressed="!valid" @click.prevent="saveItem('/items')">Save</v-btn>
              <v-btn flat :color="valid ? 'primary' : 'disabled'" :depressed="!valid" @click="deleteItem()">Discard</v-btn>
            </div>
          </div>
        </v-flex>

        <v-flex class="lg2 hidden-md-and-down">
          <div class="v-card sticky">
            <div class="card-title semibold px-2 py-2">
              Item Summary
            </div>
            <v-divider></v-divider>
            <div class="px-2 py-2">
              <item-summary :item="project"></item-summary>
            </div>
            <v-divider></v-divider>
            <div v-if="hasFiles" class="px-2 py-2">
              <div v-if="project.file.files.preview"><a @click.prevent="saveItem(project.file.files.preview, true)">Preview File</a></div>
              <div v-if="project.file.files.cover"><a @click.prevent="saveItem(project.file.files.cover, true)">Cover File</a></div>
              <div v-if="project.file.files.content"><a @click.prevent="saveItem(project.file.files.content, true)">Content File</a></div>
              <div v-if="project.file.files.original"><a @click.prevent="saveItem(project.file.files.original, true)">Original File</a></div>
            </div>

            <div class="center-align px-2 py-4">
              <fancy-price :price="unitPrice()">{{nextPrice()}}</fancy-price>
              <div>
                <span class="cart-control center-align">
                  <v-icon @mousedown="changeQuantity(-1)">mdi-minus</v-icon>
                  <input class="quantity" name="quantity" size=4 maxlength=3 v-model="quantity" placeholder="QTY" mast="###">
                  <v-icon @mousedown="changeQuantity(1)">mdi-plus</v-icon>
                </span>
              </div>
              <v-btn class="mx-0" @click="updateCart(project.id, quantity)" :color="valid ? 'primary' : 'disabled'" :depressed="!valid">Add To Cart</v-btn>
            </div>
            <v-btn block color="primary" :disabled="!hasCartItems" to="/checkout">Check Out</v-btn>
          </div>
          <br>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<style lang="sass">
.hidden
  display: none

.preview
  height: 290px
  width: 440px
  overflow-x: scroll
  overflow-y: hidden

.pages
  overflow: hidden
  text-align: center

  .pages-container
    overflow: hidden
    margin: 20px

  .page-number
    float: left
    text-align: center
    display: inline-block
    width: 220px

.cover-file
  width: 440px
  max-height: 284px
  display: inline-block

.dropzone
  background: #333
  color: white

.hidden
  display: none
</style>

<script>
  import api from '@/api/gungho'
  import Events from '@/api/events'
  import FancyPrice from '../widgets/fancy-price'
  import RadioGroup from '../widgets/gh-radio-group'
  import ItemSummary from '../widgets/item-summary'
  import DialogLoader from '../widgets/dialog-loader'

  export default {
    components: {
      FancyPrice,
      RadioGroup,
      ItemSummary,
      DialogLoader
    },

    data () {
      return {
        validForm: false,
        project: false,
        quantity: 1,
        pages: 0,
        fileProgress: 0,
        showProgress: false,
        uploadCount: 0,
        processing: false,
        pinnedCheckbox: true,
        dropable: '',
        transmitOptions: {
          acceptedFileTypes: ['application/pdf'],
          createImageThumbnailsblank: false,
          maxFiles: 1,
          maxFileSize: 1000000000,
          paramName: 'pdf[file]',
          headers: {
            'GUNGHO-ACCESS-TOKEN': this.$session.get('sessionToken')
          },
          url: '',
          adapterOptions: {
            params: {
              'pdf[product_id]': 1
            }
          }
        },
        requiredRules: [
          v => !!v || 'Cannot be blank'
        ]
      }
    },

    metaInfo () {
      return {
        title: `${this.project.name || 'Create'}`
      }
    },

    computed: {
      cart: {
        get () {
          return this.$store.state.cart
        }
      },

      hasCartItems () {
        if (!this.cart || !this.cart.cart_items) return false
        return this.cart.cart_items.length > 0
      },

      valid () {
        return !!this.project.name &&
               !!this.project.file &&
               !!this.project.file.binding &&
               !!this.project.file.bleed &&
               !!this.project.file.content_pages &&
               !!this.project.file.ink &&
               !!this.project.file.printing &&
               !!this.project.file.first_page &&
               !!this.project.file.last_page
      },

      hasFiles () {
        return !!this.project.file && !!this.project.file_id
      },

      hideIfHasFiles () {
        if (this.hasFiles) {
          return 'hidden'
        }
      },

      binding () {
        return this.project.file.binding
      },

      ink () {
        return this.project.file.ink
      },

      bleed () {
        return this.project.file.bleed
      }
    },

    watch: {
      '$route' (to, from) {
        if (this.$route.params.id) this.loadItem()
        else this.newItem()
      },

      'project.file.first_page': function () {
        this.recalcPages()
      },

      'project.file.last_page': function () {
        this.recalcPages()
      },

      'project.file.printing': function () {
        this.recalcPages()
      },

      'project.file.binding': function () {
        this.updateUnitPrice()
      },

      'project.file.ink': function () {
        this.updateUnitPrice()
      },

      'project.file.content_pages': function () {
        this.updateUnitPrice()
      },

      'quantity': function () {
        if (parseInt(this.quantity) >= 500) {
          this.quantity = 1
          Events.$emit('error', 'Please Contact Gung-Ho for pricing on 500+ quantities')
        }
      }
    },

    methods: {
      property (name) {
        if (!this.project || !this.project.product) {
          return false
        }

        return this.project.product.properties.find(
          function (obj) {
            return obj.name === name
          }
        )
      },

      recalcPages () {
        if (!this.project.file.original_pages) return 0
        var pages = this.project.file.original_pages
        if (this.project.file.first_page === 'use') pages -= 1
        if (this.project.file.last_page === 'use') pages -= 1
        if (pages % 2) pages += 1
        if (this.project.file.printing === 'single') pages = pages * 2
        this.project.file.content_pages = pages
        this.project.file.page_count = pages
      },

      updateUnitPrice () {
        if (this.project.file.original_pages) {
          this.project.file.page_count = this.project.file.content_pages
          api.unitPrices(this.project.file).then(data => {
            this.project.unit_price = data.unit_price
            this.project.unit_prices = data.unit_prices
          }).catch(error => {
            console.log(error)
          })
        }
      },

      updateProgress (file, progress) {
        this.fileProgress = progress
        if (progress >= 100) this.processingUpload()
      },

      processingUpload (file) {
        this.processing = true
        Events.$emit('toast', 'Building preview')
      },

      onUploadSuccess (file, data) {
        this.showProgress = false
        this.$refs.uploader.removeAllFiles({cancelInProgressUploads: false})

        if (data.error) return this.uploadError(data.error)

        this.project.file_id = data.pdf.id
        this.project.file.id = data.pdf.id
        this.project.file.files = data.pdf.files
        this.project.file.thumbs = data.pdf.thumbs
        this.project.file.original_pages = data.pdf.original_pages
        this.project.file.content_pages = data.pdf.content_pages > 0 ? data.pdf.content_pages : data.pdf.original_pages
        Events.$emit('toast', 'File uploaded')
      },

      uploadError (error) {
        Events.$emit('error', error.message)
      },

      onTimeout () {
        console.log('Upload processing timeout')
      },

      onDraging () {
        this.dropable = 'dropzone'
      },

      onDroped () {
        this.dropable = 'dropzone'
      },

      errorUploading (file) {
        this.showProgress = false
        this.$refs.uploader.removeAllFiles({cancelInProgressUploads: false})
        console.log(
          'Upload Error: ',
          this.transmitOptions.method,
          this.transmitOptions.url,
          JSON.parse(JSON.stringify(file))
        )
        Events.$emit('error', 'File upload error (unknown)')
      },

      triggerBrowse () {
        this.$refs.uploader.triggerBrowseFiles()
      },

      nextPrice () {
        if (this.quantity < 5) {
          return this.$options.filters.currency(this.project.unit_prices[5]) + ' for 5–99 Qty'
        } else if (this.quantity < 100) {
          return this.$options.filters.currency(this.project.unit_prices[100]) + ' for 100-249 Qty'
        } else if (this.quantity < 250) {
          return this.$options.filters.currency(this.project.unit_prices[250]) + ' for 250-499 Qty'
        } else {
          return ''
        }
      },

      unitPrice () {
        if (this.quantity >= 250 && this.quantity < 500) return this.project.unit_prices[250]
        else if (this.quantity >= 100 && this.quantity < 250) return this.project.unit_prices[100]
        else if (this.quantity >= 5 && this.quantity < 100) return this.project.unit_prices[5]
        if (this.quantity < 5) return this.project.unit_prices[1]
      },

      changeQuantity (by) {
        this.quantity = parseInt(this.quantity)
        if ((this.quantity + by) > -1 && (this.quantity + by) < 500) {
          this.quantity += by
        }
      },

      async saveItem (path, blank) {
        if (!this.isValid()) return false
        if (blank) var pdfWindow = window.open()

        await this.saveOrUpdateItem().then((project) => {
          this.project = project
          this.$refs.createItemForm.resetValidation()
          if (path) {
            if (blank) {
              pdfWindow.location = path
            } else if (path) {
              this.$router.push(path)
            }
          }
        })
      },

      saveOrUpdateItem () {
        return new Promise((resolve, reject) => {
          if (this.project.id) {
            resolve(this.updateItem())
          } else {
            resolve(this.createItem())
          }
        }).catch(error => {
          console.log(error)
        })
      },

      createItem () {
        return api.saveProject(this.project).then((data) => {
          Events.$emit('toast', 'Item Created')
          return data.project
        })
      },

      updateItem () {
        return api.updateProject(this.project).then((data) => {
          Events.$emit('toast', 'Item Updated')
          return data.project
        })
      },

      deleteItem () {
        this.$confirm('Are you sure you want to delete this item?').then(confirmed => {
          if (!confirmed) return

          if (this.project.id) {
            api.destroyProject(this.project.id).then(data => {
              Events.$emit('toast', 'Item Deleted')
              this.$router.push('/items')
            })
          } else {
            this.$router.push('/items')
          }
        })
      },

      updateCart (id, quantity) {
        if (!this.isValid()) return false

        this.saveItem().then(() => {
          this.$store.dispatch('addCartItem', {
            'project_id': this.project.id,
            'quantity': this.quantity
          })
        })
      },

      isNotSet (v) {
        return v === undefined || v === null
      },

      pageLimit () {
        if (this.project.pages < 20) {
          Events.$emit('toast', 'Perfect Binding requires a minimum of 10 sheets (20 pages)')
        }
      },

      isValid () {
        if (this.$refs.createItemForm) {
          this.$refs.createItemForm.validate()
        }

        if (!this.hasFiles) {
          Events.$emit('error', 'PDF file required')
          return false
        } else if (!this.valid) {
          Events.$emit('error', 'Missing required fields')
          return false
        } else if (this.project.file.content_pages < 20 && this.project.file.binding === 'perfect') {
          Events.$emit('error', 'Perfect Binding requires a minimum of 10 sheets (20 pages)')
          return false
        } else {
          return true
        }
      },

      fileType () {
        var fileType = this.project.file_type
        if (fileType) return fileType.toLowerCase()
        else return 'pdf'
      },

      fileUploadUrl () {
        if (this.project.file_id) {
          return `${process.env.API_URL}/${this.fileType()}s/${this.project.file.id}`
        } else {
          return `${process.env.API_URL}/${this.fileType()}s`
        }
      },

      setDefaults () {
        for (var i in this.project.product.properties) {
          var property = this.project.product.properties[i]
          if (this.isNotSet(this.project.file[property.name])) {
            this.$set(this.project.file, property.name, property.default)
          }
        }
      },

      newItem () {
        var name = this.$route.params.product_name
        if (!name || name === '') name = '1'

        api.product(name).then(data => {
          this.project = {
            name: '',
            unit_prices: {},
            product_id: data.product.id,
            product: data.product,
            file_id: null,
            file_type: data.product.kind,
            file: {
              product_id: data.product.id,
              content_pages: 0,
              original_pages: 0,
              files: {},
              thumbs: {},
              unit_prices: {}
            }
          }
          this.transmitOptions.url = this.fileUploadUrl()
          this.transmitOptions.method = 'post'
          this.transmitOptions.params = { 'pdf[product_id]': data.product.id }
          this.setDefaults()
        }).catch(error => {
          console.log(error)
        })
      },

      loadItem () {
        api.project(this.$route.params.id).then(data => {
          this.project = data.project
          this.transmitOptions.url = this.fileUploadUrl()
          this.transmitOptions.method = 'put'
          this.transmitOptions.params = { 'pdf[product_id]': data.project.product_id }
          this.setDefaults()
        }).catch(error => {
          console.log(error)
        })
      }
    },

    beforeMount () {
      if (this.$route.params.id) this.loadItem()
      else this.newItem()
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?5f9b7d44